import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView/HomeView.vue";


const routes = [
  /*首页路由*/
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/newsdetai",
    name: "newsdetai",
    component: () => import("../views/HomeView/NewsDetail.vue"),
  },
  {
    path: "/noticeboard",
    name: "noticeboard",
    component: () => import("../views/HomeView/NoticeBoard.vue"),
  },
  {
    path: "/researchnews",
    name: "researchnews",
    component: () => import("../views/HomeView/ResearchNews.vue"),
  },
  {
    path: "/academicdynamics",
    name: "academicdynamics",
    component: () => import("../views/HomeView/Academicdynamics.vue"),
  },
  {
    path: "/我校成功入选全国第二批人工智能助推教师队伍建设试点高校",
    name: "我校成功入选全国第二批人工智能助推教师队伍建设试点高校",
    component: () =>
      import(
        "../components/我校成功入选全国第二批人工智能助推教师队伍建设试点高校.vue"
      ),
  },
  {
    path: "/实验室项目立项",
    name: "实验室项目立项",
    component: () => import("../components/实验室项目立项.vue"),
  },

  /*实验室概况路由路由*/
  { path: "/LabMainFrame",
    name: "LabMainFrame",
    component: () => import("../views/AboutLab/LabMainFrame.vue"),
    children: [
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutLab/AboutLab.vue"),
  },
  {
    path: "/researchdirections",
    name: "researchdirections",
    component: () => import("../views/AboutLab/ResearchDirections.vue"),
  },
  {
    path: "/labstructure",
    name: "labstructure",
    component: () => import("../views/AboutLab/LabStructure.vue"),
  },
  {
    path: "/labLeadership",
    name: "labLeadership",
    component: () => import("../views/AboutLab/LabLeadership.vue"),
  },
  {
    path: "/labCommittee",
    name: "labCommittee",
    component: () => import("../views/AboutLab/LabCommittee.vue"),
  },
  {
    path: "/rulesandregulations",
    name: "rulesandregulations",
    component: () => import("../views/AboutLab/RulesandRegulations.vue"),
  },
  {
    path: '/LabRunRules',
    name: 'LabRunRules',
    component: () => import('../views/AboutLab/LabRunRules.vue')
  },
   {
    path: '/BanGongShi',
    name: 'BanGongShi',
    component: () => import('../views/AboutLab/BanGongShi.vue')
  },
   {
    path: '/DangAnGuanLi',
    name: 'DangAnGuanLi',
    component: () => import('../views/AboutLab/DangAnGuanLi.vue')
  },
   {
    path: '/XueShuWeiYuanHui',
    name: 'XueShuWeiYuanHui',
    component: () => import('../views/AboutLab/XueShuWeiYuanHui.vue')
  },
  {
    path: '/YiQiSheBei',
    name: 'YiQiSheBei',
    component: () => import('../views/AboutLab/YiQiSheBei.vue')
  },
  {
    path: '/ShiYanShiZhangCheng',
    name: 'ShiYanShiZhangCheng',
    component: () => import('../views/AboutLab/ShiYanShiZhangCheng.vue')
  },
    ],
  },


  /*研究队伍路由*/
  {
    path: "/ResearMainFrame",
    name: "ResearMainFrame",
    component: () => import("../views/ReserachTeam/ResearMainFrame.vue"),
    children: [
      {
        path: "/reserachstaff",
        name: "reserachteam",
        component: () => import("../views/ReserachTeam/ResearchStaff.vue"),
      },
      {
     path: "/researchlab",
     name: "researchlab",
     component: () => import("../views/ReserachTeam/ResearchLab.vue"),
      },
    ],
  },


  /*科学研究路由*/
  {
    path: "/Research",
    name: "research",
    component: () => import("../views/ScientificResearch/Research.vue"),
    children: [
      {
        name: "researchproject",
        path: "/ResearchProject",
        component: () =>
          import("../views/ScientificResearch/ResearchProject.vue"),
      },
      {
        name: "Team",
        path: "/Team",
        component: () => import("../views/ScientificResearch/Team.vue"),
      },
      {
        name: "qklw",
        path: "/qklw",
        component: () => import("../views/ScientificResearch/qklw.vue"),
      },
      {
        name: "xwlw",
        path: "/xwlw",
        component: () => import("../views/ScientificResearch/xwlw.vue"),
      },
      {
        name: "sjzz",
        path: "/sjzz",
        component: () => import("../views/ScientificResearch/sjzz.vue"),
      },
      {
        name: "rjzz",
        path: "/rjzz",
        component: () => import("../views/ScientificResearch/rjzz.vue"),
      },
      {
        name: "kyzl",
        path: "/kyzl",
        component: () => import("../views/ScientificResearch/kyzl.vue"),
      },
      {
        name: "xgdm",
        path: "/xgdm",
        component: () => import("../views/ScientificResearch/xgdm.vue"),
      },
      {
        name: "sjj",
        path: "/sjj",
        component: () => import("../views/ScientificResearch/sjj.vue"),
      },
    ],
  },

  /*示范平台路由*/
  {
    path: "/03platform",
    name: "03platform",
    component: () => import("../views/ExhibitionPlatform/03Platform.vue"),
  },
  {
    path: "/mmplatform",
    name: "mmplatform",
   component: () => import("../views/ExhibitionPlatform/Renzhi/login.vue"),
  },

  /*人才培养路由*/
  {
    path: "/TalentDevelopmentMainFrame",
    name: "TalentDevelopmentMainFrame",
    component: () => import("../views/TalentDevelopment/MainFrame.vue"),
    children: [
      {
        path: "/graduatestudent",
        name: "graduatestudent",
        component: () =>
          import("../views/TalentDevelopment/GraduateStudent.vue"),
      },
      {
        path: "/Ph.D student",
        name: "Ph.D student",
        component: () => import("../views/TalentDevelopment/Ph.D student.vue"),
      },
      {
        path: "/mentordirectory",
        name: "mentordirectory",
        component: () =>
          import("../views/TalentDevelopment/MentorDirectory.vue"),
      },
      {
        path: "/enrollmentinformation",
        name: "enrollmentinformation",
        component: () =>
          import("../views/TalentDevelopment/EnrollmentInformation.vue"),
      },
      {
        path: "/trainingprogram",
        name: "trainingprogram",
        component: () =>
          import("../views/TalentDevelopment/TrainingProgram.vue"),
      },
    ],
  },

  // /*条件设备路由*/
  // {
  //   path: "/instrumentandequipment",
  //   name: "instrumentandequipment",
  //   component: () =>
  //     import("../views/ConditioningEquipment/InstrumentandEquipment.vue"),
  // },

  /*开放合作路由*/
  // {
  //   path: "/developmentfund",
  //   name: "developmentfund",
  //   component: () => import("../views/OpenCooperation/DevelopmentFund.vue"),
  // },
  {
    path: "/studentlecture",
    name: "studentlecture",
    component: () => import("../views/OpenCooperation/StudentLecture.vue"),
  },
  {
    path: "/researchnews1",
    name: "researchnews1",
    component: () => import("../views/OpenCooperation/ResearchNews1.vue"),
  },
	{
		path: '/file-viewer',
		name: 'FileViewer',
		component: ()=>import("../views/FileViewer.vue"),
		props: route => ({ 
			fileUrl: route.query.fileUrl, // 从 URL 参数获取文件地址
			fileType: route.query.fileType // 从 URL 参数获取文件类型（如 pdf、docx）
		}),
	}
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
